import { IconArrowRight, IconMapPin } from '@react/common/icons'

function LocationCard({ location, onClick }) {
  return (
    <div data-id={location.id} onClick={onClick} className={`group relative flex cursor-pointer bg-tan`}>
      <div className="flex-shrink-0 w-1/3">
        {location.thumbnail && (
          <img src={location.thumbnail} loading="lazy" alt={location.title} className="object-cover w-full h-full" />
        )}
      </div>

      <div className="flex relative flex-1 py-8 px-6 lg:px-8 2xl:px-12">
        <div className="my-auto w-full">
          <h2 className="font-semibold leading-snug transition-colors 2xl:text-lg 2xl:leading-snug text-green group-hover:text-blue">
            {location.title}
          </h2>

          <div className="flex gap-2 items-start mt-2 text-sm lg:text-base">
            <IconMapPin className="flex-shrink-0 w-4" />

            <address>
              {location.address}
              <br />
              {location.city}, {location.state} {location.zip}
            </address>
          </div>
        </div>

        <button
          type="button"
          className="flex absolute right-0 bottom-0 w-8 h-8 text-white rounded-tl-xl transition-colors lg:w-12 lg:h-12 bg-green group-hover:bg-blue"
        >
          <span className="sr-only">View {location.title}</span>
          <IconArrowRight className="m-auto w-1/2" />
        </button>
      </div>
    </div>
  )
}

export default LocationCard
